import { motion } from "framer-motion";
import { MouseEventHandler } from "react";
import { DefaultTooltip } from "@/components/default-tooltip";

interface Props extends Omit<React.ComponentPropsWithoutRef<"svg">, "onClick"> {
  percentage: number; // 0-100
  onClick: MouseEventHandler<SVGCircleElement>;
}

// The size of the donut, a value that works well with the desired radius of 100.
const size = 56;

// We want to have a total of 100% for the dasharray representing the donut.
const radius = 100 / (2 * Math.PI);

// Represents 25%, causing donut to start drawing from the top instead of the right.
const offset = 25;

export const DonutChart: React.FC<Props> = ({
  className,
  percentage,
  onClick,
  ...props
}) => (
  <svg
    className={className}
    {...props}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.circle
      initial={{ strokeDashoffset: offset, strokeDasharray: "0 100" }}
      animate={{ strokeDashoffset: offset + 100, strokeDasharray: "100 0" }}
      transition={{ duration: 0.5 }}
      cx={size / 2}
      cy={size / 2}
      r={radius}
      fill="transparent"
      strokeWidth="16"
      className="stroke-secondary-background"
    />
    {percentage > 0 && (
      <DefaultTooltip
        asChild
        content={`${percentage.toFixed(1)}% of devices in RFM`}
      >
        <motion.circle
          initial={{
            strokeDashoffset: offset,
            strokeDasharray: "0 100",
          }}
          animate={{
            strokeDashoffset: offset + percentage,
            strokeDasharray: `${percentage} ${100 - percentage}`,
          }}
          transition={{ duration: 0.5 }}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          strokeWidth="16"
          onClick={onClick}
          className="cursor-pointer stroke-status-red"
        />
      </DefaultTooltip>
    )}
  </svg>
);
